module.exports = __webpack_public_path__ + "static/colors-tagging-content-do-347bf8fb3a89218741a127fd6e69d9e6.png";